













































import scrollService from '@/core/scroll/scroll.service';
import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';
import { UserModule } from '@/store/modules/user/user.store';
import { BugTrackerIssueSummaryViewModel, BugTrackerStatus } from '@/types/apiServerContract';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BugTrackerDetails extends Vue {
    get summary(): BugTrackerIssueSummaryViewModel | null {
        return BugTrackerModule.summary;
    }

    async getDetails() {
        await BugTrackerModule.getIssuesSummary();
    }

    async search(fixed: boolean) {
        await BugTrackerModule.search({
            onlyOpenIssues: null,
            onlyOwnIssues: null,
            assignedToSelf: null,
            term: null,
            categoryId: null,
            realmId: null,
            startDate: null,
            endDate: null,
            status: fixed ? this.fixedStatusCode : null,
            priority: null,
            page: null
        });

        this.scrollToTop();
    }

    get fixedStatusCode() {
        return BugTrackerStatus.Fixed;
    }

    get isLoggedIn() {
        return UserModule.IsLoggedIn;
    }

    created() {
        this.getDetails();
    }

    scrollToTop() {
        const element = document.getElementById('main-content');
        if (element) {
            scrollService.scrollToElement(element, -200);
        }
    }

    mounted() {
        this.scrollToTop();
    }
}
